import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, BankBranchDTO, PaymentProviderDTO} from '@sollapay/types';

export const openBankingApi = {
  fetchProviders: (client: HttpClient): Promise<ApiResponse<PaymentProviderDTO[]>> =>
    client.get<ApiResponse<PaymentProviderDTO[]>>('/open-banking/providers'),
  fetchBranches: (client: HttpClient, bankCode: string): Promise<ApiResponse<BankBranchDTO[]>> =>
    client.get<ApiResponse<BankBranchDTO[]>>(`/open-banking/providers/${bankCode}/branches`)
};
